export const WULANS_EMAIL = 'wulan.mantiri@gmail.com'
export const WULANS_COUNTRY_CODE = '+65'
export const WULANS_PHONE = '88304779'

export const LINKEDIN_URL = 'https://www.linkedin.com/in/wulanmantiri'
export const RESUME_URL =
  'https://docs.google.com/document/d/1vpZY2XUapj5eSqvjY_VzAOYkHeqgZrfNQ8X9Q9oiJkA/export?format=pdf'
export const EMAIL_URL = `mailto:${WULANS_EMAIL}`
export const PHONE_URL = `tel:${WULANS_COUNTRY_CODE}${WULANS_PHONE}`

export const PROFILE_PIC_URL =
  'https://drive.google.com/uc?export=view&id=1pW2YTSBG9YRn3I44xY7osOV9mJEwvnNQ'
export const WULANS_DESCRIPTION = `
  I am a CS UI fresh graduate with keen interests towards ##full-stack web
  development##.
`
